import React, { useEffect, useState } from 'react';
import Modal from '../../../../components/modal';
import styles from './style.module.scss';
import { Formik } from 'formik';
import * as Yup from "yup";
import AddLogo from '../add/add-logo';
import TextInput from '../../../../components/form/text-input';
import Switch from '../../../../components/form/switch';
import ButtonIcon from '../../../../components/ButtonIcon/ButtonIcon';
import { addBank, updateBank } from '../../../../../api';
import useProcessorStore from '../../../../stores/processor';
import toast from 'react-hot-toast';

const schema = Yup.object({
  logo_image: Yup.string(),
  processor_name: Yup.string().required("* Processor Name is required"),
  active: Yup.boolean(),
});

const AddProcessor = ({
  isOpen,
  onClose,
  isEdit,
  fetchData
}) => {

  const activeBank = useProcessorStore((state) => state.activeBank);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    logo_image: "",
    processor_name: "",
    active: false,
  });

  useEffect(() => {
    setFormData({
      logo_image: "",
      processor_name: activeBank?.name || "",
      active: activeBank?.status == 1 ? true : false,
    });

  }, [activeBank])

  const [is_submitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (values, props) => {
    setIsLoading(true);
    const toastId = isEdit ? toast.loading('Updating...') : toast.loading('Adding Processor...');
    const form_data = new FormData();

    if (values.logo_image) {
      form_data.append('bank_image', values.logo_image);
    }
    form_data.append('name', values.processor_name);

    if (isEdit) {
      form_data.append('id', activeBank?.id);
      form_data.append('status', values?.active ? 1 : 0);
    }

    try {
      const response = isEdit ? await updateBank(form_data) : await addBank(form_data);
      if (response?.status) {
        toast.success(isEdit ? "Updated Successfully" : "Added Successfully", { id: toastId });
        onClose();
        fetchData();
      } else {
        toast.error("Something went wrong", { id: toastId });
      }
    } catch (error) {
      if (error?.data?.errors) {
        setErrors(error?.data?.errors);
      }
      toast.error("Something went wrong", { id: toastId });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={"Add Processor"}
    >
      <div className={styles.container} >
        <Formik

          enableReinitialize
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={formData}
          initialErrors={errors}
          validateOnBlur={false}
          validateOnChange={is_submitted}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form autoComplete="off" className={styles.formContainer} onSubmit={handleSubmit} >
              <AddLogo />
              <TextInput
                id={'processor_name'}
                label={"Processor Name"}
                name={"processor_name"}
                placeholder={"Processor Name"}
                value={values?.processor_name}
                onChange={handleChange}
                errored={errors?.processor_name}
                error={errors?.processor_name}
                touched={touched?.processor_name}
              />

              {isEdit && (
                <Switch
                  label={"Active"}
                  id={'active'}
                  name={'active'}
                  defaultChecked={values.active}
                  onChange={handleChange}
                />
              )}


              <div className={styles.buttonContainer}>
                <ButtonIcon
                  bgColor={'#FFF'}
                  textColor='#254FE2'
                  type="button"
                  onClick={onClose}
                >
                  Cancel
                </ButtonIcon>

                <ButtonIcon
                  bgColor={'#254FE2'}
                  textColor='#FFF'
                  type="submit"
                  isLoading={isLoading}
                >
                  Save
                </ButtonIcon>
              </div>

            </form>
          )}
        </Formik>

      </div>
    </Modal>
  )
}

export default AddProcessor;